module.exports = __webpack_public_path__ + "img/p60-xinwen-xuekan-1985.8e265b68.jpg";